import React from "react";
import WithRoutify from "../../../hoc/WithRoutify";
import WithRouter from "../../../hoc/WithRouter";
import RxntPrescriptionHistory from "../../ResultContainer/RxntPrescriptionHistory";

const PrescriptionsHistoryList = (props) => {
  const { patientDetails } = props;
  return (
    <div id="home" className="tab-pane active show" role="tabpanel">
      <div className="sh_innerPortview">
        <div className="p-2">
          <div className="sh_cardBox sh_chartboxht shadow-none border">
            <RxntPrescriptionHistory
              isFromEmployeeHistory={true}
              employee_id={patientDetails.employee_id}
              patientDetails={patientDetails}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithRouter(WithRoutify(PrescriptionsHistoryList));
